<template>
  <div class="boox-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>{{ $t('router.faq') }}</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="
            $router.push({
              name: 'faqAdd',
              query: {
                ...$route.query
              }
            })
          "
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t('commonMsg.new') }}
        </button>
      </div>
    </div>
    <div class="boox-faq-main">
      <el-card class="boox-faq-main-left" :body-style="{ padding: '0px' }">
        <div slot="header">
          <span>类别</span>
        </div>
        <div class="boox-list-menu">
          <div style="flex:1;" v-bar>
            <div>
              <Draggable
                v-model="faqCategory"
                @change="changeCategory"
                :animation="150"
              >
                <div
                  v-for="item in faqCategory"
                  :key="item._id"
                  class="boox-list-menu-item"
                  :class="{ menuActive: item._id === $route.query.categoryId }"
                  @click="getCategoryDetails(item)"
                >
                  <p>{{ item.name }}（{{ item.count }}）</p>
                  <div class="boox-list-btn">
                    <i
                      class="el-icon-edit"
                      @click.stop="updateFaqCategory(item)"
                    ></i>
                    <i
                      class="el-icon-close"
                      @click.stop="delFaqCategory(item)"
                    ></i>
                  </div>
                </div>
              </Draggable>
            </div>
          </div>
          <button
            class="global-button-style"
            style="margin:0;"
            @click="$store.commit('windowHandle', 'addPopup')"
          >
            <i class="el-icon-plus"></i>
          </button>
        </div>
      </el-card>

      <el-card class="app-table-container" :body-style="{ padding: '20px' }">
        <div class="global-body-wrap" ref="wrap">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :height="tableHeight"
            row-key="_id"
            style="width: 100%;height: 100%;overflow-y: scroll;"
          >
            <el-table-column
              type="index"
              align="center"
              label="序号"
              :key="Math.random()"
              width="50"
            >
              <template slot-scope="scope">
                <span>{{
                  (params.page - 1) * params.limit + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" align="center" label="标题">
            </el-table-column>
            <el-table-column prop="updatedAt" align="center" label="日期">
              <template slot-scope="scope">
                <span>{{ scope.row.updatedAt | filterDate }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="updatedAt" align="center" label="发布状态">
              <template slot-scope="scope">
                <span v-if="scope.row.public === 0">未发布</span>
                <span v-if="scope.row.public === 1" class="green">已发布</span>
              </template>
            </el-table-column> -->
            <el-table-column label="管理" align="center">
              <template slot-scope="scope">
                <!--<span @click="toView(scope.row._id)" class="checkDetailsBtn">查看详情</span>-->
                <span @click="toEdit(scope.row._id)" class="checkDetailsBtn"
                  >编辑</span
                >
                <!-- <span
                  v-if="scope.row.public === 0"
                  @click="toPublic({ id: scope.row._id, public: 1 })"
                  class="checkDetailsBtn"
                  >发布</span
                > -->
                <!-- <span
                v-if="scope.row.public === 1"
                @click="toPublic({ id: scope.row._id, public: 0 })"
                class="checkDetailsBtn"
                >下架</span
              > -->
                <span class="checkDetailsBtn" @click="toStick(scope.row)"
                  >置顶</span
                >
                <span @click="toDel(scope.row._id)" class="delBtn">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <Pagination
          :pageSize="params.limit"
          :total="total"
          @pageNum="pageNum"
        />
      </el-card>
    </div>

    <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
    <AddComponent
      v-if="addPopup"
      :title="'添加类别'"
      :ruleForm="ruleForm"
      :ruleProps="ruleProps"
      :rules="rules"
      @addEvn="addEvn"
    />
  </div>
</template>

<script>
import AddComponent from '@/components/addPopup'
import DelPopup from '@/components/delPopup'
import Pagination from '@/components/pagination'
import { mapGetters } from 'vuex'
import Draggable from 'vuedraggable'
import Sortable from 'sortablejs'

export default {
  components: {
    Draggable,
    DelPopup,
    AddComponent,
    Pagination
  },
  computed: {
    ...mapGetters(['addPopup']),
    delPopup: {
      get: function() {
        return this.$store.state.popup.delPopup
      },
      set: function(newValue) {
        this.$store.state.popup.delPopup = newValue
        this.$store.state.popup.appModal = newValue
      }
    },
    tableHeight() {
      return window.innerHeight - 250
    },
    ruleProps() {
      let ruleProps = [
        {
          prop: 'name',
          label: '名称',
          placeholder: '请输入名称'
        }
      ]
      return ruleProps
    },
    rules() {
      let rules = {
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      }
      return rules
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      params: { limit: 10000, page: 1, sortBy: 'createdAt' },
      booxItem: null,
      updateId: '',
      faqCategory: [],
      ruleForm: {
        name: ''
      }
    }
  },
  created() {
    this.getFaqCategory()
  },
  methods: {
    async changeCategory({ moved }) {
      let { newIndex, oldIndex, element } = moved
      let ordinal
      if (newIndex === 0) {
        // 拖到第一位置
        let timeStamp = new Date().getTime()
        ordinal = (this.faqCategory[newIndex + 1].ordinal + timeStamp) / 2
      } else if (newIndex === this.faqCategory.length - 1) {
        // 拖到最后位置
        let oldLastItem = this.faqCategory[newIndex - 1]
        ordinal = oldLastItem.ordinal
        if (this.faqCategory.length === 2) {
          let timeStamp = new Date().getTime()
          oldLastItem.ordinal = timeStamp
        } else {
          oldLastItem.ordinal =
            (ordinal + this.faqCategory[newIndex - 2].ordinal) / 2
        }
        let params = {
          cateId: oldLastItem._id,
          ordinal: oldLastItem.ordinal
        }
        await this.$http.updateFaqCategory(params)
      } else {
        ordinal =
          (this.faqCategory[newIndex + 1].ordinal +
            this.faqCategory[newIndex - 1].ordinal) /
          2
      }
      let params = {
        cateId: element._id,
        ordinal
      }
      await this.$http.updateFaqCategory(params)
    },

    async getFaqCategory() {
      let res = await this.$http.getFaqCategory()
      this.faqCategory = res.data.results
      if (!this.faqCategory.length) return

      let categoryId = this.$route.query.categoryId
        ? this.$route.query.categoryId
        : this.faqCategory[0]._id
      let categoryName = this.$route.query.categoryName
        ? this.$route.query.categoryName
        : this.faqCategory[0].name

      this.params.category = categoryId

      if (!this.$route.query.categoryId) {
        this.$router.push({
          name: 'faq',
          query: {
            categoryId,
            categoryName
          }
        })
      }
      this.getList()
    },

    async getCategoryDetails(item) {
      this.$router.push({
        name: 'faq',
        query: {
          categoryId: item._id,
          categoryName: item.name
        }
      })
      this.params.category = item._id
      this.params.page = 1
      this.getList()
    },

    async addEvn(data) {
      await this.$http.createFaqCategory(data)
      this.$store.commit('windowHandle')
      this.getFaqCategory()
    },

    async updateFaqCategory(item) {
      try {
        let { value } = await this.$prompt(' ', '重命名', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: item.name,
          inputPattern: /\S/,
          // inputValidator: v => {
          //   if (!v) return false;
          // },
          inputErrorMessage: '名称不能为空'
        })
        let params = {
          cateId: item._id,
          name: value
        }
        await this.$http.updateFaqCategory(params)
        if (this.$route.query.categoryId === item._id) {
          this.$router.push({
            name: 'faq',
            query: {
              categoryId: item._id,
              categoryName: value
            }
          })
        }
        this.elMsg(this.$t('alertMsg.editSuccess'), 'success')
        this.getFaqCategory()
      } catch (error) {}
    },

    async delFaqCategory(item) {
      await this.$http.delFaqCategory({ cateId: item._id })
      if (this.$route.query.categoryId === item._id) {
        this.$router.push({
          name: 'faq',
          query: {
            categoryId: this.faqCategory[0]._id,
            categoryName: this.faqCategory[0].name
          }
        })
      }
      this.elMsg(this.$t('alertMsg.delSuccess'), 'success')
      this.getFaqCategory()
    },

    // 表格行拖拽
    rowDrop() {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      Sortable.create(tbody, {
        onEnd: (obj) => {
          this.tableDrop(obj)
        }
      })
    },

    async tableDrop(obj) {
      let { newIndex, oldIndex } = obj
      const currRow = this.tableData.splice(oldIndex, 1)[0]
      this.tableData.splice(newIndex, 0, currRow)
      const currIndex = this.tableData.indexOf(currRow)
      let ordinal
      if (newIndex === 0) {
        // 拖到第一位置
        let timeStamp = new Date().getTime()
        ordinal = (this.tableData[currIndex + 1].ordinal + timeStamp) / 2
      } else if (newIndex === this.tableData.length - 1) {
        // 拖到最后位置
        let oldLastItem = this.tableData[currIndex - 1]
        ordinal = oldLastItem.ordinal
        oldLastItem.ordinal =
          (ordinal + this.tableData[currIndex - 2].ordinal) / 2
        let params = {
          ordinal: oldLastItem.ordinal
        }
        await this.$http.putFaq(oldLastItem._id, params)
      } else {
        ordinal =
          (this.tableData[currIndex + 1].ordinal +
            this.tableData[currIndex - 1].ordinal) /
          2
      }
      let params = {
        ordinal
      }
      await this.$http.putFaq(currRow._id, params)
      this.getList()
    },

    // 表格操作按钮
    tableHandle(type) {
      if (type === 'del') {
        this.$http.delFaq(this.updateId).then((res) => {
          this.updateId = ''
          this.delPopup = false
          this.elMsg(this.$t('alertMsg.delSuccess'), 'success')
          this.getList()
        })
      }
    },
    //  确认删除
    deleteHandle() {
      this.$store.commit('windowHandle', 'delPopup')
      this.tableHandle('del')
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #f7f7f7;font-weight: 500;'
      }
    },
    getList() {
      this.$http.getFaqList(this.params).then((res) => {
        this.tableData = res.data.results
        this.total = res.data.count
      })
    },
    toEdit(id) {
      this.$router.push({
        name: 'faqAdd',
        query: { id, ...this.$route.query }
      })
    },
    toDel(id) {
      this.updateId = id
      this.delPopup = true
    },
    async toStick(data) {
      let obj = Object.assign({}, data)
      obj.ordinal = new Date().getTime()
      await this.$http.putFaq(obj._id, obj)
      this.elMsg(this.$t('alertMsg.editSuccess'), 'success')
      this.getList()
    },
    // toPublic(data) {
    //   this.$http.publicFaq({ id: data.id, data: data }).then(res => {
    //     this.getList();
    //     this.elMsg(this.$t("alertMsg.publicSuccess"), "success");
    //   });
    // },
    toView(id) {
      this.$router.push({ name: 'faqView', query: { id: id } })
    },
    pageNum(page) {
      this.params.page = page
      this.getList()
    }
  },
  watch: {},
  mounted() {
    this.rowDrop()
  }
}
</script>

<style lang="scss">
.boox-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .boox-faq-main {
    flex: 1;
    display: flex;
    overflow: hidden;
    .boox-faq-main-left {
      margin: 20px 0 20px 20px;
      width: 250px;
      display: flex;
      flex-direction: column;
      > .el-card__body {
        flex: 1;
        display: flex;
        overflow: hidden;
      }
      .boox-list-menu {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .boox-list-menu-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 5px;
          padding: 10px;
          cursor: pointer;
          &:hover {
            background: #f3f6f9;
            > .boox-list-btn {
              display: block;
            }
          }
          .boox-list-btn {
            min-width: 50px;
            display: none;
            > i {
              margin-left: 10px;
            }
          }
        }
        .menuActive {
          background: #f3f6f9;
        }
      }
    }
  }
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .boox-dialog-item {
    padding-bottom: 10px;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
  }
  .green {
    color: #28c328;
  }
}
</style>
